<script lang="ts">
    export let alt: string | undefined;
    export let height: number | undefined;
    export let width: number | undefined;
    export let style: string | undefined;
</script>

<img src="./assets/logo.png" {height} {width} alt={alt ? alt : 'logo'} {style}>